/* eslint-disable */
import { useMemo, useEffect, useState } from "react";

// react-router-dom components
import { Link } from "react-router-dom";

// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

// react-chartjs-2 components
import { Doughnut } from "react-chartjs-2";
import { Pie } from "react-chartjs-2";

// @mui material components
import Card from "@mui/material/Card";
import Tooltip from "@mui/material/Tooltip";
import Grid from "@mui/material/Grid";
import Icon from "@mui/material/Icon";

// Soft UI Dashboard PRO React components
import SuiBox from "components/SuiBox";
import SuiTypography from "components/SuiTypography";
import SuiButton from "components/SuiButton";

// Soft UI Dashboard PRO React example components
import ComplexReportsDoughnutChartItem from "./ComplexReportsDoughnutChartItem";

// ComplexReportsDoughnutChart configurations
import configs from "./configs";
import { Divider } from "@mui/material";

function ComplexReportsDoughnutChart({ title, chart, tooltip, action }) {
  const { data, options } = configs(chart.labels, chart.datasets);
  const [total, setTotal] = useState(0);
  const renderItems = chart.labels.map((label, key) => (
    <ComplexReportsDoughnutChartItem
      image={chart.images && chart.images[key]}
      title={label}
      key={label}
      percentage={`${chart.datasets.data[key]}`}
      hasBorder={key !== chart.labels.length - 1}
    />
  ));

  const getTotal = () => {
    let total = 0;
    chart.datasets.data.map((v) => (total = total + v));
    setTotal(total);
  };

  useEffect(() => {
    getTotal();
  }, [data]);

  const renderButton = () => {
    let template;

    if (action) {
      template =
        action.type === "internal" ? (
          <SuiBox mt={3} mb={2}>
            <SuiButton
              component={Link}
              to={action.route}
              variant="gradient"
              buttonColor={action.color}
              size="small"
            >
              {action.label}
            </SuiButton>
          </SuiBox>
        ) : (
          <SuiBox mt={3} mb={2}>
            <SuiButton
              component="a"
              href={action.route}
              target="_blank"
              rel="noreferrer"
              variant="gradient"
              buttonColor={action.color}
              size="small"
            >
              {action.label}
            </SuiButton>
          </SuiBox>
        );
    }

    return template;
  };

  return (
    <Card className="h-100">
      <SuiBox alignItems="center" pt={1} px={2}>
        <SuiBox mb={1}>
          <SuiTypography variant="h6" textAlign="center">
            {title}
          </SuiTypography>
        </SuiBox>
        {/* <Tooltip title={tooltip} placement="right">
          <SuiButton variant="outlined" buttonColor="secondary" size="small" circular iconOnly>
            <Icon className="">priority_high</Icon>
          </SuiButton>
        </Tooltip> */}
      </SuiBox>
      <SuiBox position="relative" p={1}>
        <Grid container spacing={2}>
          <Grid item xs={12} lg={6} className="text-center">
            <SuiBox height="100%" display="flex" flexDirection="column">
              <SuiBox height="100%" mt={5} mx={1}>
                {useMemo(
                  () => (
                    <Pie data={data} options={options} />
                  ),
                  [chart]
                )}
              </SuiBox>
              {renderButton()}
            </SuiBox>
          </Grid>
          <Grid item xs={12} lg={6}>
            {useMemo(() => renderItems, [chart])}
            <Divider />
            <SuiBox display="flex" justifyContent="flex-end" pt={1} px={2}>
              <SuiTypography variant="h6">{`Initial set: ${total}`}</SuiTypography>
            </SuiBox>
          </Grid>
        </Grid>
      </SuiBox>
    </Card>
  );
}

// Setting default values for the props of ComplexReportsDoughnutChart
ComplexReportsDoughnutChart.defaultProps = {
  tooltip: "",
  action: false,
};

// Typechecking props for the ComplexReportsDoughnutChart
ComplexReportsDoughnutChart.propTypes = {
  title: PropTypes.string.isRequired,
  chart: PropTypes.shape({
    images: PropTypes.arrayOf(PropTypes.string),
    labels: PropTypes.arrayOf(PropTypes.string).isRequired,
    datasets: PropTypes.objectOf(
      PropTypes.oneOfType([PropTypes.object, PropTypes.array, PropTypes.string])
    ).isRequired,
  }).isRequired,
  tooltip: PropTypes.string,
  action: PropTypes.oneOfType([
    PropTypes.bool,
    PropTypes.shape({
      type: PropTypes.oneOf(["external", "internal"]).isRequired,
      route: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      color: PropTypes.oneOf([
        "primary",
        "secondary",
        "info",
        "success",
        "warning",
        "error",
        "dark",
        "light",
      ]),
    }),
  ]),
};

export default ComplexReportsDoughnutChart;
